import LenisProvider from "@/components/LenisProvider";
import Grain from "@/components/Grain";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Paradox from "@/components/Paradox";
import VisitorTransformation from "@/components/VisitorTransformation";
import Omnichannel from "@/components/Omnichannel";
import ZeroIntervention from "@/components/ZeroIntervention";
import EditorialMarquee from "@/components/EditorialMarquee";
import InlineEnquiryForm from "@/components/InlineEnquiryForm";
import FooterCTA from "@/components/FooterCTA";

export default function Landing() {
  return (
    <LenisProvider>
      <div
        data-testid="landing-root"
        className="relative min-h-screen bg-obsidian text-bone antialiased"
      >
        <Grain />
        <Navbar />
        <main>
          <Hero />
          <Paradox />
          <VisitorTransformation />
          <Omnichannel />
          <ZeroIntervention />
          <EditorialMarquee />
          <InlineEnquiryForm />
          <FooterCTA />
        </main>
      </div>
    </LenisProvider>
  );
}
